// toastUtils.js
import { toast } from "react-toastify";

export const showAppMessageToast = ({
  type = "info",
  title,
  message,
  showHomeButton = false,
  navigate,
}) => {
  toast(
    ({ closeToast }) => (
      <div style={{ minWidth: 250 }}>
        {title && <strong style={{ display: "block", marginBottom: 4 }}>{title}</strong>}
        {message && <span>{message}</span>}
        {showHomeButton && (
          <div style={{ marginTop: 8 }}>
            <button
              onClick={() => {
                navigate("/");
                closeToast();
              }}
              style={{
                background: "none",
                border: "none",
                textDecoration: "underline",
                color: "#0d6efd",
                cursor: "pointer",
              }}
            >
              Back to Home
            </button>
          </div>
        )}
      </div>
    ),
    { type }
  );
};
